export default __webpack_public_path__ + "static/media/avatarMario.a20c78d5.jpg";